
var imageLess = {};
import genaration from '../../utils/classname';
export var imageClass = genaration(imageLess, 'image');